import React from 'react';
import { isEmpty } from 'lodash';
import { Icon } from 'ui';

const GroupedItems = ({
  expanded,
  onClick,
  loading,
  items,
  label,
  renderItem,
}) => (
  <div
    className={
      'fz-base c-brand-gray-darker p-4 pos-r ' + (expanded ? '' : 'mb-4')
    }
  >
    <div className="ai-c d-f">
      <div
        className="c-p us-n"
        onClick={onClick}
        onKeyDown={e => e.key === 'Enter' && onClick()}
        tabIndex="0"
        role="button"
      >
        <Icon name={expanded ? 'caret_down' : 'caret_right'} />
        <span>{label}</span>
      </div>
      {loading && <span className="Spinner ml-8 mt-1" />}
    </div>
    {expanded && !isEmpty(items) && (
      <div className="pl-16 mt-4 mb-0-lc" children={items.map(renderItem)} />
    )}
  </div>
);

export default GroupedItems;
